<template>
  <div class="personal-info">
    <div class="form-main">
      <div class="row">
        <div class="col-12">
          <div
            class="form-group mb-3"
            :class="{ 'form-group--error': $v.formData.anrede.value.$error }"
          >
            <div class="d-flex justify-content-start align-items-center">
              <label class="text-blue font-weight-bold mb-0 mr-2 mr-md-4"
                >Anrede wählen</label
              >
              <label
                id="anrede-herr-label"
                class="
                  checkbox-group
                  text-blue
                  mb-0
                  mr-2 mr-md-4
                  font-weight-bold
                "
              >
                Herr
                <input
                  id="anrede-herr"
                  type="radio"
                  name="anrede"
                  value="Herr"
                  v-model.trim.lazy="$v.formData.anrede.value.$model"
                />
                <span class="checkmark"></span>
              </label>
              <label
                id="anrede-frau-label"
                class="
                  checkbox-group
                  text-blue
                  mb-0
                  mr-2 mr-md-4
                  font-weight-bold
                "
              >
                Frau
                <input
                  id="anrede-frau"
                  type="radio"
                  name="anrede"
                  value="Frau"
                  v-model.trim.lazy="$v.formData.anrede.value.$model"
                />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6">
          <div
            class="form-group mb-3"
            :class="{ 'form-group--error': $v.formData.vorname.value.$error }"
          >
            <label for="vorname" class="text-blue font-weight-bold mb-0"
              >Vorname</label
            >
            <input
              id="vorname"
              v-model.trim.lazy="$v.formData.vorname.value.$model"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div
            class="form-group mb-3"
            :class="{ 'form-group--error': $v.formData.nachname.value.$error }"
          >
            <label for="lastname" class="text-blue font-weight-bold mb-0"
              >Nachname</label
            >
            <input
              id="lastname"
              v-model.trim.lazy="$v.formData.nachname.value.$model"
              type="text"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6">
          <div
            class="form-group mb-3"
            :class="{ 'form-group--error': $v.formData.email.value.$error }"
          >
            <label for="email" class="text-blue font-weight-bold mb-0"
              >E-Mail*</label
            >
            <input
              id="email"
              v-model.trim.lazy="$v.formData.email.value.$model"
              type="email"
              class="form-control"
              required
            />
            <div
              class="validation-error"
              v-if="!$v.formData.email.value.required"
            >
              Bitte ausfüllen
            </div>
            <div class="validation-error" v-if="!$v.formData.email.value.email">
              E-Mail ist ungültig
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div
            class="form-group mb-3"
            :class="{ 'form-group--error': $v.formData.telefon.value.$error }"
          >
            <label for="telefon" class="text-blue font-weight-bold mb-0"
              >Telefonnummer</label
            >
            <input
              id="telefon"
              v-model.trim.lazy="$v.formData.telefon.value.$model"
              type="tel"
              class="form-control"
              required
            />
            <div
              class="validation-error"
              v-if="!$v.formData.telefon.value.phoneNumber"
            >
              Telefonnummer ist ungültig
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <small class="text-right form-text text-muted text-blue small"
            >* Pflichtfelder</small
          >
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div
            class="form-group mb-3 mt-2 mb-0"
            :class="{ 'form-group--error': $v.formData.terms.value.$error }"
          >
            <label class="checkbox-group text-blue">
              <small>
                  Durch die Anforderung dieses persönlichen Angebots bestätigen Sie, 
                  dass Sie auch in Zukunft weitere Informationen von uns zu 
                  dem Thema erhalten wollen. Diese Einwilligung erfolgt freiwillig 
                  und kann von Ihnen jederzeit widerrufen werden. Wir verarbeiten 
                  Ihre Daten datenschutzkonform. Details finden Sie in unserer 
                  <a
                  class="text-blue"
                  style="text-decoration: underline"
                  href="/datenschutz"
                  target="_blank"
                  >Datenschutz</a>.*
              </small>
              <input
                name="dataPrivacy"
                type="checkbox"
                v-model.trim.lazy="$v.formData.terms.value.$model"
                required
              />
              <span class="checkmark checkmark-small"></span>
            </label>
            <div
              class="validation-error"
              v-if="!$v.formData.terms.value.mustBeTrue"
            >
              Bitte ausfüllen
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="justify-content-between d-flex">
      <div>
        <button
          id="06-zurueck"
          @click="goBack()"
          class="btn btn-outline-primary text-uppercase btn-sm-md-down"
        >
          ZURÜCK
        </button>
      </div>
      <div>
        <!-- <button
          id="06-weiter"
          v-on:click="validateForm()"
          class="btn btn-primary text-uppercase btn-sm-md-down"
        >
          WEITER
        </button> -->
        <button
          id="07-absenden"
          v-on:click="validateForm()"
          class="btn btn-primary text-uppercase btn-sm-md-down"
          :disabled="isLoading"
        >
          ABSENDEN
        </button>
      </div>
    </div>
  </div>
</template>


<script>
import { required, email, helpers } from "vuelidate/lib/validators";
const phoneNumber = helpers.regex("telefon", /^[0-9\+\(\)\-\s]+$/);
const mustBeTrue = (value) => value === true;
const isHerrOrFrau = (value) => value == "Herr" || value == "Frau";
export default {
  data() {
    return {
      isLoading: false,
      errors: {},
    };
  },
  methods: {
    goBack() {
      this.$emit("goBack");
    },
    validateForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        // do your submit logic here
        // this.$emit("goForward");
        this.submitForm();
      }
    },
    async submitForm() {
      let _this = this;
      this.errors = {};

      if (!this.isLoading) {
        this.isLoading = true;

        // Recaptcha
        // Execute reCAPTCHA and get the token
        const token = await new Promise((resolve, reject) => {
            grecaptcha.ready(function () {
            grecaptcha.execute(window.recaptchaKey, { action: 'submit' }).then(token => {
                resolve(token);
            });
            });
        });
        
        const url = "/api/konfigurator-submit";
        const data = {
          configurationData: _this.configurationData,
          personalData: _this.formData,
          token,
        };
        axios
          .post(url, data)
          .then((response) => {
            _this.isLoading = false;
            if (response.data.success) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                configuratorConversion: "1",
                event: "configuratorConversion",
              });
              _this.$emit("formSubmitted");
            } else {
              _this.errors = { errors: ["Versuchen Sie es bitte erneut."] };
            }
          })
          .catch(function (error) {
            if (error.response.data.errors) {
              _this.errors = error.response.data.errors;
            }
            _this.isLoading = false;
          });
      } else {
        return;
      }
    },
  },
  validations: {
    formData: {
      anrede: {
        value: {
          // isHerrOrFrau,
        },
      },
      vorname: {
        value: {
          // required,
        },
      },
      nachname: {
        value: {
          // required,
        },
      },
      email: {
        value: {
          required,
          email,
        },
      },
      telefon: {
        value: {
          phoneNumber,
        },
      },
      terms: {
        value: {
          mustBeTrue,
        },
      },
    },
  },
  props: {
    formData: Object,
    configurationData: Object,
  },
};
</script>